<template>
  <div class="app-container">
    <el-form class="header-filter">
      <div class="filter-container">
        <div class="filter-form">
          <el-form-item>
            <el-input
              v-model="query.nickname"
              @keyup.enter.native="resetList"
              placeholder="用户名"
            ></el-input>
          </el-form-item>
          <el-form-item>
            <el-select v-model="query.refRole" placeholder="角色" clearable>
              <el-option
                v-for="(item, index) in roles"
                :key="index"
                :label="item.name"
                :value="item.code"
              />
            </el-select>
          </el-form-item>
        </div>
        <div class="filter-btns">
          <el-button @click="resetList" type="primary">确认查询</el-button>
          <el-button @click="handleCreate">新增</el-button>
        </div>
      </div>
    </el-form>

    <div class="table-wrapper">
      <el-table :data="list" v-loading="listLoading">
        <el-table-column align="center" type="index" width="60" label="#"></el-table-column>
        <el-table-column align="center" prop="account" label="用户名"></el-table-column>
        <el-table-column align="center" prop="nickname" label="姓名"></el-table-column>
        <el-table-column align="center" prop="roleName" label="角色"></el-table-column>
        <el-table-column align="center" prop="status" label="状态">
          <template slot-scope="scope">
            <el-switch
              @change="handleEditStatus(scope.row)"
              :disabled="scope.row.statusDisabled"
              v-model="scope.row.status"
              :active-value="1"
              :inactive-value="0"
            />
          </template>
        </el-table-column>
        <el-table-column align="center" width="240" label="创建时间">
          <template slot-scope="scope">
            {{ scope.row.createTime | formatDate }}
          </template>
        </el-table-column>

        <el-table-column align="left" label="表格操作" width="230" fixed="right">
          <template slot-scope="scope">
            <p>
              <el-button @click="handleUpdate(scope.row)" type="primary" size="small">
                编辑
              </el-button>
              <el-button @click="handleDelete(scope.row.code)" size="small" type="danger">
                删除
              </el-button>
            </p>
          </template>
        </el-table-column>
      </el-table>

      <div class="pagination-container">
        <el-pagination
          background
          layout="total, sizes, prev, pager, next, jumper"
          @size-change="handleSizeChange"
          @current-change="handleCurrentChange"
          :current-page="query.page"
          :total="listTotal"
          :page-sizes="[10, 20, 30, 50]"
        />
      </div>
    </div>

    <admin-dialog ref="dialog" :roles="roles" @listenPostSuccess="getList"></admin-dialog>
  </div>
</template>

<script>
import { getAdminList, getRoleList, freezeAdmin, deleteAdmin } from '@/api/admin'
import AdminDialog from './components/admin-dialog'

export default {
  components: {
    AdminDialog
  },

  data() {
    return {
      // table
      list: [],
      listTotal: null,
      listLoading: false,
      roles: [],

      query: {
        deptId: 0,
        limit: 10,
        current: 1,
        nickname: ''
      }
    }
  },

  created() {
    this.resetList()
    this.getRoles()
  },

  methods: {
    resetList() {
      this.query.current = 1
      this.getList()
    },

    getList() {
      this.listLoading = true

      getAdminList(this.query).then((res) => {
        const {
          data: {
            records,
            pager: { itemCount }
          }
        } = res
        this.list = records.map((item) => {
          item.statusDisabled = item.code === 1
          return item
        })
        this.listTotal = +itemCount
        this.listLoading = false
        console.log('object :>> ', this.list)
      })
    },

    getRoles() {
      getRoleList({ limit: 1000 }).then((res) => {
        console.log('res----- :>> ', res)
        const {
          data: { records }
        } = res
        this.roles = records
      })
    },

    handleSizeChange(val) {
      this.query.limit = val
      this.resetList()
    },

    handleCurrentChange(val) {
      this.query.current = val
      this.getList()
    },

    handleCreate() {
      this.$refs.dialog.handleCreate()
    },

    handleUpdate(row) {
      this.$refs.dialog.handleUpdate(row)
    },

    handleEditStatus(row) {
      row.statusDisabled = true

      if (row.status === 1) {
        freezeAdmin(row.code, false).then(() => {
          this.$message.success('解冻用户成功')
          row.statusDisabled = false
        })
      } else {
        freezeAdmin(row.code, true).then(() => {
          this.$message.success('禁用用户成功')
          row.statusDisabled = false
        })
      }
    },

    handleDelete(code) {
      this.$confirm('此操作将永久删除该用户, 是否继续?', '提示', {}).then(() => {
        deleteAdmin(code).then(() => {
          this.$message.success('删除用户成功')
          this.getList()
        })
      })
    }
  }
}
</script>
